module.exports = __webpack_public_path__ + "img/newchris-64.13871395.jpg";